export const environment = {
    production: true,
    apiUrl: 'https://sys.bondsclub.com.br/api/mobile.php?action=',
    applicationApiUrl: 'https://admin.appsbonds.club//api',
    applicationApiId: '3',
    partnerId: 736146
};